<template>
  <span class="input-wrp">
    <!-- Инпут телефона (с маской) -->
    <input
        v-if="input_type === 'phone'"
        class="customInput"
        :placeholder="placeholder"
        :style="{marginBottom: mb}"
        :type="type"
        :value="value"
        :max="type === 'number' ? '99999' : null"
        :step="step"
        ref="input"
        v-mask="'+7 (999) 999 99 99'"
        @input="$emit('input', $refs.input.value)"
        @change="$emit('change', $refs.input.value)"
    >
    <!-- Инпут обычный -->
    <input
        v-else
        class="customInput"
        :placeholder="placeholder"
        :style="{marginBottom: mb}"
        :type="type == 'password' ? !show ? type : 'text' : type"
        :value="value"
        :max="type === 'number' ? '99999' : null"
        :step="step"
        ref="input"
        @input="$emit('input', $refs.input.value)"
        @change="$emit('change', $refs.input.value)"
    >
    <div class="icon" @click="show = !show" v-if="type == 'password'">
        <svg v-if="show" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="#DBBFA7" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 6 C 17.276 6 19.944594 10.267094 20.808594 11.996094 C 19.943594 13.713094 17.255 18 12 18 C 6.724 18 4.0554062 13.732906 3.1914062 12.003906 C 4.0574062 10.286906 6.745 6 12 6 z M 12 8 C 9.791 8 8 9.791 8 12 C 8 14.209 9.791 16 12 16 C 14.209 16 16 14.209 16 12 C 16 9.791 14.209 8 12 8 z M 12 10 C 13.105 10 14 10.895 14 12 C 14 13.105 13.105 14 12 14 C 10.895 14 10 13.105 10 12 C 10 10.895 10.895 10 12 10 z"></path>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="#DBBFA7" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"></path>
        </svg>
      </div>
  </span>
</template>

<script>
export default {
  name: 'custom-input',
  props: {
    value: [String, Number],
    placeholder: String,
    mb: String,
    input_type: String,
    type: {
      type: String,
      default: 'text'
    },
    step: [String, Number],
  },
  mounted(){
   if(this.type == 'password') this.show = false;
  },
  data: () => ({
    show: true
  })
}
</script>

<style scoped lang="scss">
.input-wrp{
  position: relative;

  & .icon{
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    margin-top: -10px;
    top: 50%;
    right: 10px;

    & * {
      margin-top: 0;
    }
  }
  .customInput {
    font-family: "Open Sans", sans-serif;
    background-color: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    width: 100%;
    height: 50px;
    padding-left: 20px;
    font-size: 16px;
    line-height: 1.5;

    &::placeholder {
      color: #808080;
    }

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type=number] {
      -moz-appearance: textfield;
    }
  }
}
</style>
